const SHOPIFY_ADMIN_URL = "https://admin.shopify.com";

const styles = {
  wrap: {
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    background: "#f6f6f7",
    padding: "48px 24px",
    boxSizing: "border-box",
  },
  card: {
    width: "100%",
    maxWidth: "440px",
    background: "#fff",
    borderRadius: "16px",
    padding: "40px 32px",
    textAlign: "center",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
  },
  mark: {
    width: "64px",
    height: "64px",
    margin: "0 auto 24px",
    borderRadius: "16px",
    background: "#008060",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  title: {
    fontSize: "22px",
    fontWeight: 600,
    color: "#202223",
    lineHeight: 1.3,
  },
  body: {
    fontSize: "14px",
    color: "#6d7175",
    lineHeight: 1.6,
    marginTop: "8px",
  },
  cta: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    marginTop: "24px",
    width: "100%",
    background: "#008060",
    color: "#fff",
    fontSize: "14px",
    fontWeight: 500,
    padding: "10px 20px",
    borderRadius: "8px",
    textDecoration: "none",
    boxSizing: "border-box",
  },
  footer: {
    fontSize: "12.5px",
    color: "#6d7175",
    marginTop: "24px",
    lineHeight: 1.6,
  },
  link: {
    color: "#008060",
    fontWeight: 500,
    textDecoration: "none",
  },
};

/**
 * Shown when the app is opened directly in a browser tab (not embedded in the
 * Shopify Admin iframe). The admin UI relies on App Bridge session tokens that
 * are only available inside Shopify Admin, so we present a friendly landing
 * page instead of a broken dashboard.
 */
export default function LandingPage() {
  return (
    <div style={styles.wrap}>
      <div style={styles.card}>
        <div style={styles.mark}>
          <svg
            viewBox="0 0 24 24"
            width="32"
            height="32"
            fill="none"
            aria-hidden="true"
          >
            <path
              d="M5 5h11a1 1 0 0 1 1 1v9H8l-3 3V5Z"
              fill="none"
              stroke="#fff"
              strokeWidth="2"
              strokeLinejoin="round"
            />
            <path d="M8 8h8M8 11h5" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
          </svg>
        </div>

        <h1 style={styles.title}>Countdown Timer Bar</h1>
        <p style={styles.body}>
          This app runs inside the Shopify Admin. Open it from your store's
          admin dashboard to manage settings and analytics.
        </p>

        <a href={SHOPIFY_ADMIN_URL} style={styles.cta}>
          Open Shopify Admin
          <span aria-hidden="true">↗</span>
        </a>

        <p style={styles.footer}>
          Having trouble?{" "}
          <a href="mailto:maxifyapps@gmail.com" style={styles.link}>
            Contact support
          </a>
        </p>
      </div>
    </div>
  );
}
